import React, { Fragment } from "react";
import { Button, Grid } from "@material-ui/core";
import { ViewModule, List } from "@material-ui/icons";
import DeadDealsList from "./DeadDeals/List";
import PipelineAndDeadTiles from "./PipelineAndDeadTiles";
import TablePaginationHelper from "utils/tablePaginationHelper";

class DeadDeals extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      view: "list"
    };

    this.tablePaginationHelper = new TablePaginationHelper("2c2745dd-fcd3-4da2-8690-2ff46a7424f6", 25);
  }

  listView = () => {
    this.setState({ view: "list" });
  };

  tileView = () => {
    this.setState({ view: "tile" });
  };

  render() {
    return (
      <Fragment>
        <Grid xs={12} item style={{ marginTop: 4 }}>
          {this.state.view === "list" ? (
            <DeadDealsList {...this.props} rowsPerPage={this.tablePaginationHelper.rowsPerPage} tableConfigItemId="2c2745dd-fcd3-4da2-8690-2ff46a7424f6" />
          ) : (
            <PipelineAndDeadTiles {...this.props} />
          )}
          <Button
            className="button_tableGridChanger _List"
            onClick={this.listView}
          >
            <List />
          </Button>
          <Button
            className="button_tableGridChanger _Block"
            onClick={this.tileView}
          >
            <ViewModule />
          </Button>
        </Grid>
      </Fragment>
    );
  }
}

export default DeadDeals;